import bdServices from '@/services/bd-services'
var FormData = require('form-data')
const grupos_tpaServices = {}

grupos_tpaServices.obtenerCompanias = async function () {
  const data = await bdServices(`/servidores/tpa/sca/grupos/getCompanias.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

grupos_tpaServices.obtenerSubgrupos = async function () {
  const data = await bdServices(`/servidores/tpa/sca/grupos/getSubgrupos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

grupos_tpaServices.obtenerGrupos = async function () {
  const data = await bdServices(`/servidores/tpa/sca/grupos/getGrupos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

grupos_tpaServices.obtenerGruposSubgrupos = async function () {
  const data = await bdServices(`/servidores/tpa/sca/grupos/getGrupos_subgrupos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

grupos_tpaServices.guardarNuevoGrupo = async function (nombre, idCompania) {
  let formData = new FormData()
  formData.append('nombreGrupo', nombre)
  formData.append('idCompania', idCompania)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/grupos/addGrupo.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

grupos_tpaServices.guardarNuevoSubgrupo = async function (nombreSubgrupo, compania, grupo, tipo) {
  let formData = new FormData()
  formData.append('nombreSubgrupo', nombreSubgrupo)
  formData.append('compania', compania)
  formData.append('grupo', grupo)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/grupos/addSubgrupo.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

grupos_tpaServices.updateGrupo = async function (id, nombre) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/nominaciones/editGrupo.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

grupos_tpaServices.updateConfiguracionSubgrupo = async function (id, color, texto, etiqueta, boton) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('color', color)
  formData.append('texto', texto)
  formData.append('etiqueta', etiqueta)
  formData.append('boton', boton)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/grupos/editConfigSubgrupo.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

export default grupos_tpaServices


// WEBPACK FOOTER //
// ./src/services/sca/grupos/gruposTPA.js